import { getAccessToken } from "../../../utils/auth";
import type { LiveProctoringEventItem } from "./testTypes";

export type ProctoringWebSocketMessage =
  | { type: "NEW_VIOLATION"; data: LiveProctoringEventItem & Record<string, unknown> }
  | { type: "pong" }
  | { type: string; data?: unknown };

export const buildProctoringWebSocketUrl = (testId: string): string | null => {
  const token = getAccessToken();
  if (!token || !testId) return null;

  const apiBase = (
    process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api"
  ).replace(/\/$/, "");

  // Keep /api in the path so reverse proxies that only forward /api still
  // upgrade WebSockets (legacy /ws/proctoring often never reaches the app).
  const wsRoot = apiBase
    .replace(/^https:\/\//i, "wss://")
    .replace(/^http:\/\//i, "ws://");
  const params = new URLSearchParams({ token });
  return `${wsRoot}/ws/proctoring/${encodeURIComponent(testId)}?${params.toString()}`;
};

export const parseProctoringWebSocketMessage = (
  raw: string
): ProctoringWebSocketMessage | null => {
  try {
    return JSON.parse(raw) as ProctoringWebSocketMessage;
  } catch {
    return null;
  }
};
